export default __webpack_public_path__ + "static/media/Všeobecné Obchodní Podmínky platné od 1.6.2021 - Hostivice a Hostavice.c59142b4.pdf";